import { clsx ,Box } from 'external/material'
import {DownloadIcon, MessageIcon, SquareArrowUpRightIcon} from 'resources/icons'
import {viewerGuard, subdomainLink} from 'utils/url'
import {inViewer} from 'settings'

export default function UploadedLinks(props) {
  const {id, downloaded} = props

  return (<Box className="links">
    {props.onMessageClick && <span onClick={props.onMessageClick} className={clsx("link", "message")}><MessageIcon fill="#2c75bd" width={18} /></span>}
    {inViewer && downloaded && <a className={clsx("link", "view")} href={`//downloads/${id}`}><SquareArrowUpRightIcon fill="#2c75bd" height={20} /></a>} 
    {inViewer && !downloaded && <a
      className={clsx("link", "download")}
      {...viewerGuard({target: "_blank", href: subdomainLink('api-support', 'catalog',  'downloadUploaded', `?event=${id}`)})}
    ><DownloadIcon fill="#2c75bd" width={17} /></a>}
    </Box>)
}
